'use client';
import Link from 'next/link';
import { SupportSvg } from '../../Icons/SupportSvg';
import { useCart } from '../../../components/commerce/cart/cart-context';
import { getVisibilityFilter } from './utils';

/**
 * The cart button at the top right of the header with a cart count.
 */
export default function SupportCartButton({ data }) {
  const { cart } = useCart();
  const cartCount = cart?.totalQuantity ?? 0;

  const visibilityFilter = getVisibilityFilter(data.item_display);
  return (
    <li className={`flex pl-2 ${visibilityFilter}`}>
      <Link
        href="/cart"
        prefetch={null}
        className="group hover:text-cozy-cognac relative flex items-center"
        data-cy="header-cart-link"
      >
        {cartCount !== 0 && <CartCountIcon count={cartCount} />}
        <SupportSvg icon={data.icon} label={data.label} />
        <span className="sr-only">{data.label}</span>
      </Link>
    </li>
  );
}

const CartCountIcon = ({ count }) => {
  // Intentionally avoided using badge-text-r to use tighter spacing in one span
  return (
    <span className="font-lato text-crisp-white group-hover:bg-cozy-cognac bg-parlor-green absolute -top-1 left-4 z-10 inline-block h-4 w-4 rounded-full text-center text-xs/4 font-bold">
      {count}
    </span>
  );
};
